import { Weddings } from '@bridebook/models';
import { Agents } from '@bridebook/models/source/models/Weddings/Agents';
import { Conversations } from '@bridebook/models/source/models/Weddings/Agents/Conversations';

/**
 * The planner's server state lives on the wedding's `planner` agent document. The models
 * use the client SDK, so each store call opens its own firebase context as the couple.
 * One context for the whole streamed request would close while tools still write.
 * So every caller passes the user as well as the wedding.
 */
export type AgentScope = { weddingId: string; userId: string };

export const plannerAgent = (weddingId: string) =>
  Weddings._.getById(weddingId).Agents.getById(Agents.PLANNER);

// The agent's default conversation, which holds the thread's message chunks. One per wedding.
export const plannerConversation = (weddingId: string) =>
  plannerAgent(weddingId).Conversations.getById(Conversations.DEFAULT);
